/** The cloud storage limit every account has (5 TB). Shared by the dashboard and the Files header. */
export const STORAGE_LIMIT_BYTES = 5 * 1024 ** 4

/** Share of the limit in use, 0–100 and unrounded. */
export const storageUsedPercent = (usageBytes: number): number =>
  Math.min((Math.max(usageBytes, 0) / STORAGE_LIMIT_BYTES) * 100, 100)

/** "37%", or "<1%" for a little in use, so a non-empty storage never reads as 0%. */
export const formatStoragePercent = (usageBytes: number): string => {
  const percent = storageUsedPercent(usageBytes)
  if (percent > 0 && percent < 1) return '<1%'
  return `${Math.round(percent)}%`
}
